import React from 'react';

import { RedirectSingleton, RedirectType } from '@pkg/classes';
import {
    Web3AuthContextProvider,
    Web3AuthPanel,
    Web3AuthPanelRenderContext,
    type Web3AuthSteps,
} from '@pkg/components/Web3Auth';

import StartPage from '../StartPage';

interface W3aStandAloneFlow {
    step?: Web3AuthSteps;
}

export function W3aStandAloneFlow({ step }: W3aStandAloneFlow) {
    const sys = RedirectSingleton.getRedirect(RedirectType.Default);
    const context = sys?.includes('fantasy/teams') ? Web3AuthPanelRenderContext.Teams : undefined;

    return (
        <Web3AuthContextProvider step={step}>
            <Web3AuthPanel renderCtx={context} />
            <StartPage />
        </Web3AuthContextProvider>
    );
}
